import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { formatDollars } from '../../../utils/formatting';
import { DOLLAR_PRICE_MIN_VALUE, getMaxPriceForCoreLevel } from '../../../utils/profits';
import { MAX_TITLE_LENGTH, getFolderNameValidationErrorMessage } from '../../../utils/isValidFolderName';
import { PremiumFolderType } from '../../../types/gallection';
const useValidation = (coreLevel, isGallery, existingFolderNames)=>{
    const { t } = useTranslation();
    const maxPrice = getMaxPriceForCoreLevel(coreLevel);
    const validationSchema = useMemo(()=>yup.object({
            title: yup.string().required(t('common.validation.error.missingValue')).max(MAX_TITLE_LENGTH, ()=>t('common.validation.error.maxLength', {
                    max: MAX_TITLE_LENGTH
                })).test('is_valid_name', '', function(title = '') {
                const errorMessage = getFolderNameValidationErrorMessage(title, t, existingFolderNames, isGallery);
                if (errorMessage) {
                    return this.createError({
                        path: this.path,
                        message: errorMessage
                    });
                }
                return true;
            }),
            folderType: yup.string(),
            price: yup.number().when('folderType', {
                is: PremiumFolderType.Paid,
                then: yup.number().required(t('common.dollarPriceInput.validation.error.missingValue')).typeError(t('common.dollarPriceInput.validation.error.invalidValue')).min(DOLLAR_PRICE_MIN_VALUE, t('common.dollarPriceInput.validation.error.minValue', {
                    min: formatDollars(DOLLAR_PRICE_MIN_VALUE)
                })).max(maxPrice, t('common.dollarPriceInput.validation.error.maxValue', {
                    max: formatDollars(maxPrice)
                }))
            })
        }), [
        t,
        maxPrice,
        existingFolderNames,
        isGallery
    ]);
    return validationSchema;
};
export default useValidation;

//# sourceMappingURL=useValidation.js.map